import React from 'react';

interface NmCardProps {
  children: React.ReactNode;
  variant?: 'raised' | 'raised-lg' | 'raised-sm' | 'inset';
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

/** Core Neumorphic card container with three elevation levels. */
export function NmCard({
  children,
  variant = 'raised',
  className = '',
  style,
  onClick,
}: NmCardProps) {
  const cls = {
    raised: 'nm-card',
    'raised-lg': 'nm-card-lg',
    'raised-sm': 'nm-card-sm',
    inset: 'nm-inset',
  }[variant];

  return (
    <div
      className={`${cls} ${className}`}
      style={style}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      {children}
    </div>
  );
}
